import React from "react";
import Text from "../../../../../shared/components/Text";
import { formatMoneyNum } from "nemuru-components";
import { SummaryConditionsRow } from "../../shared/components/SummaryConditionsRow";

export const CreditLineConditions = ({ principalAmount }) => {
  return (
    <>
      <SummaryConditionsRow
        title={<Text tId="CREDIT_LINE_TOTAL" />}
        value={<>{formatMoneyNum(principalAmount)} €</>}
      />
    </>
  );
};
